// removed by extract-text-webpack-plugin
module.exports = {"resultContainer":"HGqNQp-XgcKkOzrMG6tey","eventTime":"_1tUi30jqsDNfOHcHiNnU9y","result":"_1JpTaSf8ZUXZXUgjKw3Sp4","teamName":"_3nTBZ8QAxQdbyTPwg6LnyE","basketballTitle":"_38UwymI47Ae_DW7x8t6ArD","even":"_1N02I_q3q7bEzByxl-D2AZ","eventDetailsWrapper":"_2EanoroeFbcZF6Btq3h-RG","eventDetails":"_3r7UAtq6f4ewMAWAt9gvKO","eventDetailsLine":"QpxasZKgNhbfDKsMg38tu","eventDetailsLineLeft":"_3_mDuW7xsMVye7tA1Ucr4a","eventDetailsLineRight":"_3E0grcMIIf2hxqCPMojwxK"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/lockedBetBasketball.css
// module id = 742
// module chunks = 0